import React from 'react';
import { parseDuration } from 'library/time';
import { getActiveIcon } from 'library/helpers';
import { ItemTags } from 'views/shared/ItemTags';
import { DocLink, DocPages } from 'components/Help';
import CompetencyFormInput from './input';
import { CompetencyUsers } from './Users';
import { CompetencyActivities } from './Activities';

const config = {
  // List Table
  list: {
    // Table Columns
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        defaultSortOrder: 'ascend',
        width: '280px'
      },
      {
        title: 'Competency Type',
        dataIndex: 'competency_type__name',
        width: '240px',
        sorter: true,
        render: (text, record) => (record.competency_type.name)
      },
      {
        title: 'Validity Period',
        dataIndex: 'validity_period',
        width: '240px',
        align: 'center',
        sorter: true,
        render: (text, record) => (record.validity_period ? `${parseDuration(record.validity_period).days} Days` : 'N/A')
      },
      {
        title: 'Managed in SF',
        dataIndex: 'is_integration_managed',
        width: '200px',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [
          {
            text: 'Managed in SF',
            value: true
          },
          {
            text: 'Not managed in SF',
            value: false
          }
        ],
        render: (text, record) => getActiveIcon(record.is_integration_managed)
      },
      {
        title: 'Active',
        dataIndex: 'active',
        width: '120px',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [
          {
            text: 'Active',
            value: true
          },
          {
            text: 'Inactive',
            value: false
          }
        ],
        render: (text, record) => getActiveIcon(record.active)
      }
    ],
    // Deleting
    confirmMessage: item => (
      <div>
        <p>
          Are you sure you wish to delete the competency
          {' '}
          <b>{item.name}</b>
          ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      },
      competency_type__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['competency_type__name'],
        searchValue: ''
      }
    },
    // General
    title: <DocLink page={DocPages.competencies}>Competencies</DocLink>,
    showFilter: true
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select a Competency',
    title: 'Competency',
    tabItems: [
      {
        key: 0,
        title: 'Details',
        component: props => (
          <CompetencyFormInput
            {...props}
            messages={{
              is_integration_managed: 'This data is managed by another system and cannot be edited'
            }}
            title="Competency"
          />
        )
      },
      {
        key: 1,
        title: 'Users',
        component: props => (
          <CompetencyUsers
            {...props}
          />
        )
      },
      {
        key: 2,
        title: 'Activities',
        component: props => (
          <CompetencyActivities
            {...props}
          />
        )
      },
      {
        key: 3,
        title: 'Tags',
        component: props => (
          <ItemTags
            {...props}
            themeName="competency"
          />
        )
      }
    ]
  }
};

export default config;
